import React, { useState, useEffect, useRef } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';

export default function RmToolTip({ itemText, itemType, placement, noClick, name, disabled, onClick, toolTipText, className, style, ellipsis }) {
    const [showToolTip, setShowToolTip] = useState(false);
    const [iconFontSize, setIconFontSize] = useState(0);

    const anchorRef = useRef(null);
    const timerID = useRef(0);
    const timerID2 = useRef(0);
    const mountedRef = useRef(false);
    const lastActionRef = useRef('');
    const showToolTipRef = useRef(false);

    useEffect(() => {
        mountedRef.current = true;
        const el = anchorRef.current;
        const fontSize = parseInt(window.getComputedStyle(el).fontSize, 10);
        setIconFontSize(fontSize);
        return () => {
            mountedRef.current = false;
            clearTimeout(timerID.current);
            clearTimeout(timerID2.current);
        };
    }, []);

    useEffect(() => {
        showToolTipRef.current = showToolTip;
    }, [showToolTip]);

    function handleEvent(action, e) {
        e.preventDefault();
        if (action === 'onMouseOver') {
            timerID.current = setTimeout(() => {
                if (lastActionRef.current === 'onMouseOver' && mountedRef.current) {
                    setShowToolTip(true);
                    showToolTipRef.current = true;
                    timerID2.current = setTimeout(() => {
                        if (showToolTipRef.current && mountedRef.current) {
                            setShowToolTip(false);
                        }
                    }, 2500);
                }
            }, 300);
        } else if (action === 'onMouseOut') {
            setShowToolTip(false);
        } else if (action === 'onTouchMove') {
            if (lastActionRef.current === 'onTouchStart') {
                const newShow = !showToolTipRef.current;
                setShowToolTip(newShow);
                showToolTipRef.current = newShow;
                timerID.current = setTimeout(() => {
                    if (showToolTipRef.current) setShowToolTip(false);
                }, 3000);
            }
        } else if (action === 'onClick') {
            if (!noClick) {
                setShowToolTip(false);
                if (!disabled) {
                    name !== null ? onClick({ target: { name } }) : onClick();
                }
            }
        } else if (action === 'onTouchEnd') {
            if (lastActionRef.current === 'onTouchStart') {
                if (!noClick) {
                    setShowToolTip(false);
                    if (!disabled) {
                        name !== null ? onClick({ target: { name } }) : onClick();
                    }
                }
            }
        }
        lastActionRef.current = action;
    }

    const ellipsisValue = ellipsis ? 'ellipsis' : '';

    return (
        <div style={{ ...style }}
            className={className}
            onClick={(e) => handleEvent('onClick', e)}
            onTouchStart={(e) => handleEvent('onTouchStart', e)}
            onTouchEnd={(e) => handleEvent('onTouchEnd', e)}
            onTouchMove={(e) => handleEvent('onTouchMove', e)}
            onMouseOver={(e) => handleEvent('onMouseOver', e)}
            onMouseOut={(e) => handleEvent('onMouseOut', e)}>
            <div style={{ position: 'relative' }}>
                <div ref={anchorRef}
                    style={{
                        cursor: disabled ? 'not-allowed' : noClick ? 'help' : 'pointer',
                        color: disabled ? '#1D8A8A66' : '#1D8A8A',
                        overflow: 'hidden',
                        textOverflow: ellipsisValue,
                    }}>
                    {itemType === 'icon' ?
                        <i className="material-icons" style={{ fontSize: iconFontSize + 'px', color: disabled ? '#1D8A8A66' : '#1D8A8A' }}>
                            {itemText}
                        </i> :
                        itemText}
                </div>
                <Overlay target={anchorRef.current} placement={placement} show={showToolTip}>
                    <Tooltip id={'tooltip-' + Math.floor(Math.random() * 100000)}>
                        {toolTipText}
                    </Tooltip>
                </Overlay>
            </div>
        </div>
    );
}

RmToolTip.defaultProps = {
    itemType: 'icon',
    placement: 'bottom',
    noClick: false,
    name: null,
    disabled: false,
};
